import React from 'react';

/**
 * EmailTemplateThumbnail
 *
 * Renders a scaled-down preview of an email template using an iframe.
 * Uses CSS transform to scale the content to thumbnail size while
 * maintaining the full email rendering.
 */
const EmailTemplateThumbnail = ({ htmlContent, width = 100, height = 130 }) => {
  // Scale factor to shrink the full-size email (600px wide) to thumbnail
  const iframeWidth = 600;
  const scale = width / iframeWidth;

  if (!htmlContent) {
    return (
      <div
        className="template-thumbnail template-thumbnail--empty"
        style={{ width, height }}
      >
        <div className="thumbnail-empty-content">
          <i className="fa fa-file-alt"></i>
          <span>No template</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="template-thumbnail"
      style={{
        width,
        height,
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#f8f9fa',
        borderRadius: 8,
        border: '1px solid #e2e8f0',
      }}
    >
      <div
        style={{
          width: iframeWidth,
          height: height / scale,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        <iframe
          srcDoc={htmlContent}
          title="Email preview thumbnail"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            pointerEvents: 'none',
            backgroundColor: '#ffffff',
          }}
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  );
};

export default EmailTemplateThumbnail;
